import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { Css, Responsive, Shimmer } from '../../../../ui';

export function SearchShimmer() {
	return (
		<StyledContentWrap>
			<StyledList>
				<ListItemShimmer />
				<ListItemShimmer />
				<ListItemShimmer />
			</StyledList>
		</StyledContentWrap>
	);
}
function ListItemShimmer() {
	return (
		<ListItemWrap>
			<IconContentWrap>
				<StyledShimmer width={24} height={24} />
			</IconContentWrap>
			<ListItemContentWrap>
				<StyledShimmer width="40%" height={14} minWidth="70%" />
				<StyledShimmer height={14} width="100%" minWidth="100%" />
			</ListItemContentWrap>
		</ListItemWrap>
	);
}

const StyledContentWrap = styled.div`
	width: 100%;
`;

const StyledList = styled.ul`
	display: flex;
	flex-direction: column;
	align-items: center;
	list-style: none;
	padding: 0;
	margin: 0;
	gap: ${Css.pxToRem(8)};
`;

const ListItemWrap = styled.div`
	max-width: ${Css.pxToRem(936)};
	width: 100%;
	padding: ${Css.pxToRem(18)} ${Css.pxToRem(14)};
	gap: ${Css.pxToRem(15)};
	border-radius: ${Css.pxToRem(12)};
	background-color: ${Color.PrimaryWhite};

	display: flex;
	align-items: center;
	text-decoration: none;
`;

const IconContentWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
const ListItemContentWrap = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(18)};
`;

const StyledShimmer = styled(Shimmer)<{
	width: number | string;
	height: number;
	minWidth?: string;
}>`
	${({ width, height }) =>
		`
		width: ${typeof width === 'number' ? Css.pxToRem(width) : width};
		height: ${Css.pxToRem(height)};
	`}
	background-color: ${Color.BodyBackground};
	border-radius: ${Css.pxToRem(4)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		max-width: unset;
		${({ minWidth }) => (minWidth ? `width:${minWidth}` : '')};
	}
`;
